import { render } from "./Index.vue?vue&type=template&id=3761e21d"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Home/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3761e21d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3761e21d', __exports__)) {
    api.reload('3761e21d', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=3761e21d", () => {
    api.rerender('3761e21d', render)
  })

}


export default __exports__